module.exports = __webpack_public_path__ + "static/media/white_background.aa4665f5.svg";